import get from 'lodash.get';

import isObject from '#shared/util/isObject.js';

/**
 * @typedef NSLAccountCustomer
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} emailId
 */

/**
 * @typedef NSLAccountResponse
 * @property {object} result
 * @property {NSLAccountCustomer[]} result.customers
 */

/**
 * Provider account schema (NLOK NSL)
 * @param {object} data
 * @param {NSLAccountResponse} data.providerAccount
 * @returns {object}
 */
export const providerAccountSchema = ({ providerAccount }) => {
	const [providerAccountCustomerObject] = get(providerAccount, 'result.customers', []);
	if (isObject(providerAccountCustomerObject)) {
		return {
			firstName: providerAccountCustomerObject.firstName,
			lastName: providerAccountCustomerObject.lastName,
			email: providerAccountCustomerObject.emailId
		};
	} else {
		return null;
	}
};
